var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8815 11.4403C2.01142 11.9973 2.49468 12.421 3.06667 12.421H14.2667C14.8386 12.421 15.3215 11.9971 15.4562 11.4412C15.6286 10.7302 15.8095 10.0804 15.8095 8.00005C15.8095 5.91969 15.6286 5.26992 15.4562 4.5589C15.3215 4.00302 14.8386 3.5791 14.2667 3.5791L3.06667 3.5791C2.49468 3.5791 2.01142 4.00279 1.8815 4.55983C1.7078 5.30452 1.5238 5.98338 1.5238 8.00005C1.5238 10.0167 1.7078 10.6956 1.8815 11.4403Z",
    stroke: "#969696"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.66665,
    cy: 7.99993,
    r: 1.71429,
    stroke: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07828 5.98926L4.77381 5.98032",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6854 9.98926L13.381 9.98032",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetIcon);
export default __webpack_public_path__ + "static/media/budget-icon.06e92e9228f401c8b9b5df97fe821759.svg";
export { ForwardRef as ReactComponent };